/**
 * Cart drawer: add 30% off backup cover (UPSELL-COVER variants).
 */
class TbpCartCoverUpsell extends HTMLElement {
  connectedCallback() {
    this.select = this.querySelector('[data-tbp-cover-select]');
    this.addBtn = this.querySelector('[data-tbp-cover-add]');
    this.addLabel = this.querySelector('[data-tbp-cover-add-label]');
    this.errorEl = this.querySelector('[data-tbp-cover-error]');
    this.nowEl = this.querySelector('[data-tbp-cover-now]');
    this.wasEl = this.querySelector('[data-tbp-cover-was]');
    this.saveEl = this.querySelector('[data-tbp-cover-save]');
    this.mediaEl = this.querySelector('[data-tbp-cover-media]');
    this.imgEl = this.querySelector('[data-tbp-cover-img]');

    this.select?.addEventListener('change', (e) => {
      // Don't let Dawn cart-drawer-items treat this as a quantity change
      e.stopPropagation();
      this.syncFromSelect();
    });
    this.addBtn?.addEventListener('click', () => this.addCover());
    this.syncFromSelect();
  }

  selectedOption() {
    return this.select?.selectedOptions?.[0] || null;
  }

  defaultAddLabel(save) {
    return save ? `Add cover · Save ${save}` : 'Add backup cover';
  }

  syncFromSelect() {
    const opt = this.selectedOption();
    if (!opt) return;

    const available = opt.dataset.available === 'true';
    const save = opt.dataset.save || '';

    if (this.nowEl) this.nowEl.textContent = opt.dataset.price || '';
    if (this.wasEl) {
      const compare = opt.dataset.compare || '';
      if (compare) {
        this.wasEl.textContent = compare;
        this.wasEl.hidden = false;
      } else {
        this.wasEl.textContent = '';
        this.wasEl.hidden = true;
      }
    }
    if (this.saveEl) {
      if (save) {
        this.saveEl.textContent = `Save ${save}`;
        this.saveEl.hidden = false;
      } else {
        this.saveEl.textContent = '';
        this.saveEl.hidden = true;
      }
    }
    if (this.addLabel && !this.adding) {
      this.addLabel.textContent = this.defaultAddLabel(save);
    }
    if (this.addBtn) this.addBtn.disabled = !available || this.adding;

    // Swap thumbnail when the selected cover color changes
    const imgUrl = opt.dataset.image || '';
    if (imgUrl && this.imgEl) {
      this.imgEl.src = imgUrl;
      if (opt.dataset.imageSrcset) this.imgEl.srcset = opt.dataset.imageSrcset;
      if (opt.textContent) this.imgEl.alt = opt.textContent.trim();
    } else if (imgUrl && this.mediaEl) {
      const img = this.mediaEl.querySelector('img') || document.createElement('img');
      img.className = 'tbp-cart-upsell__img';
      img.loading = 'lazy';
      img.setAttribute('data-tbp-cover-img', '');
      img.src = imgUrl;
      if (opt.dataset.imageSrcset) img.srcset = opt.dataset.imageSrcset;
      img.alt = (opt.textContent || 'Backup cover').trim();
      if (!img.parentNode) {
        this.mediaEl.innerHTML = '';
        this.mediaEl.appendChild(img);
      }
      this.imgEl = img;
    }
  }

  setError(message) {
    if (!this.errorEl) return;
    if (message) {
      this.errorEl.textContent = message;
      this.errorEl.hidden = false;
    } else {
      this.errorEl.textContent = '';
      this.errorEl.hidden = true;
    }
  }

  setLoading(loading) {
    this.adding = loading;
    const opt = this.selectedOption();
    if (!this.addBtn) return;
    this.addBtn.disabled = loading || opt?.dataset.available !== 'true';
    if (this.addLabel) {
      this.addLabel.textContent = loading
        ? 'Adding to cart…'
        : this.defaultAddLabel(opt?.dataset.save || '');
    }
  }

  async addCover() {
    const opt = this.selectedOption();
    if (!opt || opt.dataset.available !== 'true' || this.adding) return;

    const variantId = Number(opt.value);
    if (!variantId) return;

    const priceCents = Number(opt.dataset.priceCents || 0) || 0;
    this.setError('');
    this.setLoading(true);

    try {
      if (window.TBP && typeof window.TBP.addToCartAndRefresh === 'function') {
        await window.TBP.addToCartAndRefresh({ id: variantId, quantity: 1 }, { checkout: false });
      } else {
        const cart = document.querySelector('cart-drawer');
        const body = {
          items: [{ id: variantId, quantity: 1 }],
        };

        if (cart?.getSectionsToRender) {
          body.sections = cart
            .getSectionsToRender()
            .map((section) => section.id)
            .join(',');
          body.sections_url = window.location.pathname;
        }

        const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify(body),
        });
        const data = await response.json();

        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || 'Could not add cover');
        }

        if (cart?.renderContents && data.sections) {
          cart.renderContents(data);
        } else if (window.TBP?.refreshCartDrawer) {
          await window.TBP.refreshCartDrawer({ open: true });
        } else {
          window.location.href = window.routes?.cart_url || '/cart';
        }
      }

      if (window.TBP && typeof window.TBP.trackAddToCart === 'function') {
        window.TBP.trackAddToCart({
          id: opt.dataset.productId || variantId,
          variantId: variantId,
          title: 'Backup Yoga Pant Cover',
          price: priceCents,
          quantity: 1,
          unit: 'cents',
        });
      }
    } catch (err) {
      this.setError(err?.message || 'Could not add cover. Try again.');
      this.setLoading(false);
    }
  }
}

if (!customElements.get('tbp-cart-cover-upsell')) {
  customElements.define('tbp-cart-cover-upsell', TbpCartCoverUpsell);
}
